export class CreateCampaignRequest {
    name: string
    subject: string
    body: string
    fromName: string
    fromEmail: string
    replyTo: string
    listId: string
    trackingDomainId: number
    deliveryServerId: number
    sendAt: Date
    status: string
    lockTrackingDomain: boolean
}